import { render, staticRenderFns } from "./Simulador.vue?vue&type=template&id=cee938a0&scoped=true"
import script from "./Simulador.vue?vue&type=script&lang=js"
export * from "./Simulador.vue?vue&type=script&lang=js"
import style0 from "./Simulador.vue?vue&type=style&index=0&id=cee938a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee938a0",
  null
  
)

export default component.exports